import { useQuery } from "@tanstack/vue-query";
import { type MaybeRef } from "@vueuse/core";
import { api } from "@//api";

export const CAMERA_QUERY_KEY = "cameras";

export type Barrier = {
  id: string;
  name: string;
  open?: boolean;
};

export type Camera = {
  id: string;
  siteId: string | null;
  displayName: string;
  type: string;
  anprEnabled: boolean;
  barrier?: Barrier;
  liveFeedUrl?: string;
  signageIdentity?: string;
  signageViewName?: string;
};

type CameraQuery = {
  siteId: string | null;
};

const listCameras = async (query: CameraQuery) => {
  const { body } = await api.get<Camera[]>("/camera/cameras", {
    query,
  });

  return body;
};

export const useCameras = (query?: MaybeRef<CameraQuery>) => {
  const { id: currentSiteId } = useCurrentSite();

  return useQuery({
    queryKey: [
      CAMERA_QUERY_KEY,
      computed(() => ({
        ...unref(query),
        siteId: currentSiteId.value,
      })),
    ] as const,
    queryFn: ({ queryKey: [_test, query_] }) => listCameras(unref(query_)),
    staleTime: 60 * 60 * 1000,
  });
};
